import { action } from 'satcheljs';
import { ActionSource } from 'owa-analytics-actions';

export default action(
    'MARK_ITEMS_JUNK_NOT_JUNK_BASED_ON_NODE_IDS',
    (
        nodeIds: string[],
        tableViewId: string,
        isJunkValueToSet: boolean,
        actionSource: ActionSource
    ) => ({
        nodeIds,
        tableViewId,
        isJunkValueToSet,
        actionSource,
    })
);
